import { render, staticRenderFns } from "./myExam.vue?vue&type=template&id=4c63e9fa&scoped=true&"
import script from "./myExam.vue?vue&type=script&lang=js&"
export * from "./myExam.vue?vue&type=script&lang=js&"
import style0 from "./myExam.vue?vue&type=style&index=0&id=4c63e9fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c63e9fa",
  null
  
)

export default component.exports